import { uuidv7 as uuid } from "uuidv7";

export default function generateUuid() {
  return uuid();
}
